import { Button, CircularProgress } from "@mui/material";
import React from "react";
import { colors } from "../../utils/colors/Index";

const CustomButton = ({
  title = "click",
  variant = "contained",
  size = "medium",
  type = "button",
  loading = false,
  loadingSize = 20,
  handleClick = () => null,
  ...props
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      type={type}
      onClick={handleClick}
      {...props}
    >
      {loading ? (
        <CircularProgress
          size={loadingSize}
          sx={{ color: colors.background.primary }}
        />
      ) : (
        title
      )}
    </Button>
  );
};

export default CustomButton;
